var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteCloseFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:close-fill",
    clipPath: "url(#clip0_2267_122623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12.9451L15.861 17.8062C16.119 18.0642 16.4688 18.2091 16.8336 18.2091C17.1984 18.2091 17.5483 18.0642 17.8062 17.8062C18.0642 17.5483 18.2091 17.1984 18.2091 16.8336C18.2091 16.4689 18.0642 16.119 17.8062 15.8611L12.9433 11L17.8053 6.1389C17.933 6.01117 18.0342 5.85956 18.1033 5.69271C18.1723 5.52585 18.2079 5.34703 18.2078 5.16645C18.2078 4.98586 18.1722 4.80706 18.103 4.64024C18.0339 4.47342 17.9326 4.32185 17.8048 4.19419C17.6771 4.06653 17.5255 3.96527 17.3586 3.8962C17.1918 3.82714 17.013 3.79161 16.8324 3.79165C16.6518 3.7917 16.473 3.82731 16.3062 3.89645C16.1394 3.9656 15.9878 4.06692 15.8601 4.19465L11 9.05573L6.13888 4.19465C6.0121 4.06326 5.86043 3.95844 5.69271 3.8863C5.52498 3.81416 5.34458 3.77614 5.16201 3.77447C4.97944 3.7728 4.79836 3.8075 4.62935 3.87656C4.46033 3.94562 4.30676 4.04764 4.1776 4.17668C4.04844 4.30573 3.94627 4.4592 3.87705 4.62815C3.80784 4.7971 3.77296 4.97814 3.77446 5.16071C3.77596 5.34328 3.81381 5.52373 3.88579 5.69151C3.95777 5.8593 4.06245 6.01108 4.19371 6.13798L9.05663 11L4.19463 15.862C4.06336 15.9889 3.95869 16.1407 3.8867 16.3084C3.81472 16.4762 3.77688 16.6567 3.77538 16.8392C3.77388 17.0218 3.80875 17.2029 3.87797 17.3718C3.94718 17.5408 4.04935 17.6942 4.17852 17.8233C4.30768 17.9523 4.46125 18.0543 4.63026 18.1234C4.79928 18.1925 4.98035 18.2272 5.16292 18.2255C5.34549 18.2238 5.5259 18.1858 5.69362 18.1137C5.86134 18.0415 6.01302 17.9367 6.1398 17.8053L11 12.9451Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2267_122623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteCloseFill);
export default __webpack_public_path__ + "static/media/mingcute_close-fill.57cea3f97e5528b89495c0b9ee54a802.svg";
export { ForwardRef as ReactComponent };